// Overrides gameAreaBoxClasses' max-h-[80svh], which still caps the box under the inline height.
const fullscreenBoxClasses = "w-full h-full";

export default fullscreenBoxClasses;
